export default "__VITE_ASSET__CxPH1whA__"